import React from "react"
import {
  Box, Flex, Link, Text, VStack,
} from "@chakra-ui/react"
import SubmissionCard from "pages/EventShow/Submissions/FormSubmissions/FormSubmissionsDetailView/SubmissionCard"
import { DioboxEvent } from "sharedTypes"
import Icon from "components/elements/Icon"
import { PHONE_CONTAINER_QUERY } from "utilities/constants"
import GuestStatusComponent from "./GuestStatus"
import GuestNameAndEmail from "./GuestNameAndEmail"
import GuestCardButtons from "./GuestCardButtons"
import QRCode from "./QRCode"
import TemporalQRCodeComponent from "./TemporalQRCodeComponent/TemporalQRCodeComponent"

const GuestCard = ({
  guestId,
  name,
  email,
  status,
  checkedIn,
  statuses,
  qrCodeUrl,
  qrCodeText,
  guestQrPageUrl,
  event,
  event: { includePassbook, includeQrCode, expiringQrCodes },
  hideGuestCardButtons,
}: {
  guestId: string
  guestQrPageUrl?: string
  name: string
  email: string
  status: 0 | 1 | 2 | 3
  checkedIn?: boolean
  statuses: string[]
  qrCodeUrl: string
  qrCodeText: string
  event: DioboxEvent
  hideGuestCardButtons?: boolean
}) => {
  const showQRCode = status === 1 && includeQrCode
  const showGuestCardButtons = !hideGuestCardButtons && (status === 1 && !expiringQrCodes)

  return (
    <SubmissionCard>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify={{ base: "flex-start", md: "space-between" }}
        align={{ base: "stretch", md: "flex-start" }}
        sx={{
          [PHONE_CONTAINER_QUERY]: {
            flexDirection: "column", justifyContent: "flex-start", alignItems: "stretch",
          },
        }}
      >
        <Box textAlign="left" w={{ base: "100%", md: "auto" }} sx={{ [PHONE_CONTAINER_QUERY]: { w: "100%" } }}>
          <GuestStatusComponent status={status} statuses={statuses} />
          <GuestNameAndEmail name={name} email={email} />
          {showGuestCardButtons && (
            <Box
              mt={{ base: 9, md: 4 }}
              display={{ base: "none", md: "block" }}
              sx={{ [PHONE_CONTAINER_QUERY]: { display: "none" } }}
            >
              <GuestCardButtons
                includePassbook={includePassbook}
                guestExternalId={guestId}
                event={event}
              />
            </Box>
          )}
        </Box>

        {status === 1 && (
        <Flex
          direction="column"
          align="center"
          mt={{ base: 6, md: 0 }}
          flexShrink={0}
          sx={{ [PHONE_CONTAINER_QUERY]: { mt: 6 } }}
        >
          {showQRCode && (
          <Box mb={{ base: 6, md: 0 }} sx={{ [PHONE_CONTAINER_QUERY]: { mb: 6 } }}>
            {expiringQrCodes ? (
              <Link
                fontSize="xs"
                color="black"
                href={guestQrPageUrl}
                display="inline-block"
                isExternal
              >
                <VStack spacing={2} w={140}>
                  <TemporalQRCodeComponent
                    eventPrimaryColor={event.portalPrimaryColor}
                    guestId={guestId}
                    checkedIn={checkedIn}
                    qrCodeUrl={qrCodeUrl}
                    size={140}
                  />
                  <Text align="center">
                    {event.translations.temporalQrCodeForCheckIn}{" "}
                    <Icon
                      icon="link-external"
                      size={4}
                      ml={1}
                      display="inline-block"
                      verticalAlign="text-bottom"
                    />
                  </Text>
                </VStack>
              </Link>
            ) : (
              <QRCode qrCodeText={qrCodeText} qrCodeUrl={qrCodeUrl} />
            )}
          </Box>
          )}

          {showGuestCardButtons && (
          <Box display={{ base: "block", md: "none" }} sx={{ [PHONE_CONTAINER_QUERY]: { display: "block" } }}>
            <GuestCardButtons
              includePassbook={includePassbook}
              guestExternalId={guestId}
              event={event}
            />
          </Box>
          )}
        </Flex>
        )}
      </Flex>
    </SubmissionCard>
  )
}

export default GuestCard
